<div class="page-body ibm-plex-page">
  <div>
    <header [breadcrumbPath]="breadcrumb" ></header>
    <div class="title-banner">
        <tra class="secondary new-title" slug="brand_short"></tra>
        <h2><tra slug="title_attestation"></tra></h2>
      </div>
    <div class="page-content sidepanelless-content">
      <tra-md slug="mpt_attestation_header"></tra-md> 
      <div *ngFor="let instruction of attestationSteps; let i = index" style="margin-bottom: 1em;">
        <div class="sub-header">
            <tra-md [slug]="instruction.head"></tra-md>
        </div>
        <tra-md [slug]="instruction.body"></tra-md>
        <input [id]="i" type="checkbox" [(ngModel)]="instruction.is_checked" />&nbsp;
        <label style="font-weight: bold;" [for]="i"><tra slug="btn_i_accept_mpt"></tra></label>
      </div>
    </div>
  </div>
  <footer [hasLinks]="true"></footer>
</div>

